import React, { useState, useEffect, useCallback } from 'react';
import { Redirect, Link } from 'react-router-dom';
import HttpService from '../../services/httpService'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { connect } from "react-redux";
import { setUserDetails } from '../../redux/actions/userAction'
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { DataGrid } from "@material-ui/data-grid";
import '../../App.css'
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  table: {
    width: "fit-content",
    margin: '10px'
    // width: "auto", /* or specify a fixed width */
    // min-width: '100%', /* Set a minimum width */
  },
  tablecontainer: {
    display: "flex",
    margin: "25px",
  },
  tableform: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 500,
  },
  clickableTableCell: {
    cursor: "pointer",
    textDecoration: "underline",
    color: "blue",
  },
  normalTableCell: {
    color: "black",
    "&:hover": {
      cursor: "pointer",
      color: "blue", // you can change the color when hovering here
      textDecoration: "underline",
    },
  },
  tableCell: {
    color: "blue",
    cursor: "pointer",
    textDecoration: "underline",

    // Changing color, cursor and textDecoration on hovering
    // "&:hover": {
    // 	cursor: "pointer",
    // 	color: "blue", // you can change the color when hovering here
    // 	textDecoration: "underline",
    // },
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  narrowTab: {
    minWidth: "fit-content", // Adjust the width as needed
    // width:"fit-content",
    width: 65,
  },
  margin: {
    margin: theme.spacing(1),
  },
  activeButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
  },
  redButton: {
    backgroundColor: "#F50057 !important",
    color: "white !important",
    transition: "background-color 0.3s, color 0.3s",
    margin: "10px"
  },
  normalButton:{
    margin: "10px"
  },
  cardDialog: {
    minWidth: "80%",
    cursor: 'default'
  },
  autoComplete: {
    width: "200px",
  },
  searchField: {
    marginTop: "20px",
    width: "800px",
  },
  viewIssueDialog:{
    minWidth: "80%"
  },
  imageList: {
    width: 500,
    // height: 450,
  },
  dialogMargin:{
    margin: "10px",
  },
  actionBar:{ display: "flex", justifyContent: "center", gap: "10px" },
  iconHover:{
  transition: "filter 0.3s ease",
  filter: "brightness(1.3)"
  },
  reassign:{
    minWidth: "500px",
    // minHeight: "300px",
  },
  reassignAutocomplete:{
    margin: "20px",
  },
  editDialogue:{
    minWidth: "600px",
    cursor: 'default'
  },
  dateSize:{
    width: "50%"
  },
  handOnHover:{
    cursor: "pointer"
  },
  remarks:{
    border: '1px solid black'
  },
  iconDisabledColor:{
    color: 'rgb(255, 255, 255)'
  }
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#3F51B5",
    color: "#FFF",
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const DisplayPage = (props) => {
  const classes = useStyles();
  const { renderData } = props;
  const [displayData, setDisplayData] = useState(renderData);

  useEffect(()=>{
    // setDisplayData(renderData.map((el,i)=> {...el, "sNo":i+1}))
    const newArr = renderData.map((el, i) => ({
      ...el,
      id: i + 1
    }))
    setDisplayData(newArr);
    // console.log('renderData is ',renderData)
  },[renderData])

  const formatDate = (dateString) => {
    if(!dateString) return 'N/A'
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', options); // "27 Feb 2023"
  };

  const columns = [
    {
      field: 'id',
      headerName: 'S No.',
      width: 90,
      sortable: false
    },
    {
      field: 'lead_no',
      headerName: 'Lead No',
      width: 150,
      valueGetter: (params) => params.row.lead_no ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'newUniqueLeadId',
      headerName: 'new Unique LeadId',
      width: 150,
      valueGetter: (params) => params.row.newUniqueLeadId ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'uniqueLeadNumber',
      headerName: 'Unique Lead No',
      width: 200,
      valueGetter: (params) => params.row.uniqueLeadNumber ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'createdAt',
      headerName: 'createdAt',
      valueGetter: (params) => formatDate(params.row?.createdAt) ?? 'N/A',
      width: 200,
      sortable: false,
      // editable: true,
    },
    // {
    //   field: 'newUniqueProjectId',
    //   headerName: 'New Unique ProjectId',
    //   width: 200,
    //   // editable: true,
    // },
    {
      field: 'isRegistered',
      headerName: 'Is Registered',
      width: 150,
      valueGetter: (params) => params.row.isRegistered ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'floorPlan',
      headerName: 'Floor Plan',
      width: 150,
      valueGetter: (params) => params.row.floorPlan ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'address',
      headerName: 'Address',
      width: 150,
      sortable: false,
      valueGetter: (params) => params.row.address ?? 'N/A',
      renderCell: (params) => (
        <Tooltip title={params.row.address ?? ''} arrow>
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              // fontSize: '30px'
            }}
          >
            {params.row.address}
          </span>
        </Tooltip>
      ),
      // editable: true,
    },
    {
      field: 'area',
      headerName: 'Area',
      width: 150,
      valueGetter: (params) => params.row.area ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'propertyType',
      headerName: 'PropertyType',
      width: 150,
      valueGetter: (params) => params.row.propertyType ?? 'N/A',
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.row.propertyType ?? ''} arrow>
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              // fontSize: '30px'
            }}
          >
            {params.row.propertyType}
          </span>
        </Tooltip>
      ),
      // editable: true,
    },
    {
      field: 'scopeOfWork',
      headerName: 'Scope Of Work',
      width: 150,
      valueGetter: (params) => params.row.scopeOfWork ?? 'N/A',
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.row.scopeOfWork ?? ''} arrow>
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              // fontSize: '30px'
            }}
          >
            {params.row.scopeOfWork}
          </span>
        </Tooltip>
      ),
      // editable: true,
    },
    {
      field: 'startInteriors',
      headerName: 'Start Interiors',
      width: 150,
      valueGetter: (params) => params.row.startInteriors ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'city',
      headerName: 'City',
      width: 150,
      valueGetter: (params) => params.row.city ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'experienceCenterId',
      headerName: 'Experience Center',
      width: 150,
      valueGetter: (params) => params.row.experienceCenterId ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'salesWonExpCtrId',
      headerName: 'SalesWon ExpCenter',
      width: 150,
      valueGetter: (params) => params.row.salesWonExpCtrId ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'sourceOfLead',
      headerName: 'Source Of Lead',
      width: 150,
      valueGetter: (params) => params.row.sourceOfLead ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'readyToDispatchDate',
      headerName: 'readyToDispatchDate',
      valueGetter: (params) => params.row?.readyToDispatchDate ?? 'N/A',
      width: 200,
      sortable: false,
      // editable: true,
    },
    {
      field: 'designUser',
      headerName: 'Design User',
      width: 150,
      sortable: false,
      valueGetter: (params) => params.row.designUser ?? 'N/A',
      // editable: true,
    },
    {
      field: 'designStages',
      headerName: 'designStages',
      width: 150,
      valueGetter: (params) => params.row.designStages ?? 'N/A',
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.row.designStages ?? ''} arrow>
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              // fontSize: '30px'
            }}
            >
            {params.row.designStages}
          </span>
        </Tooltip>
      ),
      // editable: true,
    },
    {
      field: 'status',
      headerName: 'status',
      width: 150,
      valueGetter: (params) => params.row.status ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'designStatus',
      headerName: 'Design Status',
      width: 150,
      sortable: false,
      valueGetter: (params) => params.row.designStatus ?? 'N/A',
      // editable: true,
    },
    {
      field: 'designHoldReason',
      headerName: 'designHoldReason',
      width: 150,
      valueGetter: (params) => params.row.designHoldReason ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'expectedDesignSignOffDate',
      headerName: 'expectedDesignSignOffDate',
      valueGetter: (params) => params.row?.expectedDesignSignOffDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'assignTo',
      headerName: 'assignTo',
      width: 150,
      valueGetter: (params) => params.row.assignTo ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'teamId',
      headerName: 'teamId',
      width: 150,
      valueGetter: (params) => params.row.teamId ?? 'N/A',
      sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.row.teamId ?? ''} arrow>
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              // fontSize: '30px'
            }}
          >
            {params.row.teamId}
          </span>
        </Tooltip>
      ),
      // editable: true,
    },
    {
      field: 'departmentId',
      headerName: 'departmentId',
      width: 150,
      // editable: true,
      valueGetter: (params) => params.row.departmentId ?? 'N/A',
      sortable: false,
    },
    {
      field: 'customerId',
      headerName: 'customerId',
      width: 150,
      valueGetter: (params) => params.row.customerId ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'designerAssigned',
      headerName: 'designerAssigned',
      width: 150,
      valueGetter: (params) => params.row.designerAssigned ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'designerAssignedDate',
      headerName: 'designerAssignedDate',
      valueGetter: (params) => params.row?.designerAssignedDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'contractSignedValue',
      headerName: 'contractSignedValue',
      width: 150,
      valueGetter: (params) => params.row.contractSignedValue ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'designSignOffDate',
      headerName: 'designSignOffDate',
      valueGetter: (params) => params.row?.designSignOffDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'internalDesignSignOffDate',
      headerName: 'internalDesignSignOffDate',
      valueGetter: (params) => params.row?.internalDesignSignOffDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'designSignoffRevokeDate',
      headerName: 'designSignoffRevokeDate',
      valueGetter: (params) => params.row?.designSignoffRevokeDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'expectedSalesclosureDate',
      headerName: 'expectedSalesclosureDate',
      valueGetter: (params) => params.row?.expectedSalesclosureDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'discountPercent',
      headerName: 'discountPercent',
      width: 150,
      valueGetter: (params) => params.row.discountPercent ?? 'N/A',
      // editable: true,
    },
    {
      field: 'tokenPercent',
      headerName: 'tokenPercent',
      width: 150,
      valueGetter: (params) => params.row.tokenPercent ?? 'N/A',
      // editable: true,
    },
    {
      field: 'reasonForLost',
      headerName: 'reasonForLost',
      width: 150,
      valueGetter: (params) => params.row.reasonForLost ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'imosToFactoryDate',
      headerName: 'imosToFactoryDate',
      valueGetter: (params) => params.row?.imosToFactoryDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'salesMeetingDone',
      headerName: 'salesMeetingDone',
      width: 150,
      valueGetter: (params) => params.row.salesMeetingDone ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'salesWonUser',
      headerName: 'salesWonUser',
      width: 150,
      valueGetter: (params) => params.row.salesWonUser ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'daysAsPerContractSign',
      headerName: 'daysAsPerContractSign',
      width: 150,
      valueGetter: (params) => params.row.daysAsPerContractSign ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'tenPercentPaid',
      headerName: 'tenPercentPaid',
      width: 150,
      valueGetter: (params) => params.row.tenPercentPaid ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'amountReceivedInSales',
      headerName: 'amountReceivedInSales',
      width: 150,
      valueGetter: (params) => params.row.amountReceivedInSales ?? 'N/A',
      // editable: true,
    },
    {
      field: 'amountReceivedInDesign',
      headerName: 'amountReceivedInDesign',
      width: 150,
      valueGetter: (params) => params.row.amountReceivedInDesign ?? 'N/A',
      // editable: true,
    },
    {
      field: 'designSignOffUser',
      headerName: 'Design Sign Off User',
      width: 150,
      sortable: false,
      valueGetter: (params) => params.row.designSignOffUser ?? 'N/A',
      // editable: true,
    },
    {
      field: 'dateOfDesignKickOffMeeting',
      headerName: 'dateOfDesignKickOffMeeting',
      width: 150,
      valueGetter: (params) => params.row.dateOfDesignKickOffMeeting ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'isDesignKickOffCustomerApprovedFromDesign',
      headerName: 'isDesignKickOffCustomerApprovedFromDesign',
      width: 150,
      valueGetter: (params) => params.row.isDesignKickOffCustomerApprovedFromDesign ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'lastActivityDate',
      headerName: 'lastActivityDate',
      valueGetter: (params) => params.row?.lastActivityDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'staticSalesWonBudget',
      headerName: 'staticSalesWonBudget',
      width: 150,
      valueGetter: (params) => params.row.staticSalesWonBudget ?? 'N/A',
      // editable: true,
    },
    {
      field: 'probableDesignSignOffDate',
      headerName: 'probableDesignSignOffDate',
      valueGetter: (params) => params.row?.probableDesignSignOffDate ?? 'N/A',
      sortable: false,
      width: 150,
      // editable: true,
    },
    {
      field: 'customerDesignHoldRemark',
      headerName: 'customerDesignHoldRemark',
      width: 150,
      valueGetter: (params) => params.row.customerDesignHoldRemark ?? 'N/A',
      sortable: false,
      editable: true,
    },
    {
      field: 'designHoldSelectedTypes',
      headerName: 'designHoldSelectedTypes',
      width: 150,
      valueGetter: (params) => params.row.designHoldSelectedTypes ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'designHoldStatusApproval',
      headerName: 'designHoldStatusApproval',
      width: 500,
      sortable: false,
      valueGetter: (params) => `admApproval:${params.row?.designHoldStatusApproval.admApproval ?? 'N/A'} | odmApproval:${params.row?.designHoldStatusApproval.odmApproval ?? 'N/A'} | customerApproval:${params.row?.designHoldStatusApproval.customerApproval ?? 'N/A'} `,
      // editable: true,
    },
    {
      field: 'amountPaid',
      headerName: 'amountPaid',
      type: 'number',
      width: 150,
      valueGetter: (params) => params.row.amountPaid ?? 'N/A',
      // editable: true,
    },
    {
      field: 'salesStage',
      headerName: 'Sales Stage',
      width: 150,
      valueGetter: (params) => params?.row?.salesStage ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'salesUser',
      headerName: 'Sales User',
      width: 150,
      valueGetter: (params) => params?.row?.salesUser ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'salesAssistantManager',
      headerName: 'Sales Assistant Manager',
      width: 150,
      valueGetter: (params) => params?.row?.salesAssistantManager ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'salesManager',
      headerName: 'Sales Manager',
      width: 150,
      valueGetter: (params) => params?.row?.salesManager ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'salesDGM',
      headerName: 'Sales DGM',
      width: 150,
      valueGetter: (params) => params?.row?.salesDGM ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'meetingWithCustomer1',
      headerName: 'Meeting Date',
      width: 150,
      valueGetter: (params) => formatDate(params?.row?.meetingDate) ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'meetingWithCustomer2',
      headerName: 'Meeting Stage',
      width: 150,
      valueGetter: (params) => params?.row?.meetingStage ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'meetingWithCustomer3',
      headerName: 'Meeting Type',
      width: 150,
      valueGetter: (params) => params?.row?.meetingType ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'leadWonDate',
      headerName: 'Lead Won Date',
      width: 150,
      valueGetter: (params) => formatDate(params?.row?.leadWonDate) ?? 'N/A',
      sortable: false
      // editable: true,
    },
    {
      field: 'staticSalesWonAmount',
      headerName: 'Static Sales Won Amount',
      width: 150,
      valueGetter: (params) => params?.row?.staticSalesWonAmount ?? 'N/A',
      sortable: false,
      // editable: true,
    },
    {
      field: 'staticDesignWonAmount',
      headerName: 'Static Design Won Amount',
      width: 150,
      valueGetter: (params) => params?.row?.staticDesignWonAmount ?? 'N/A',
      sortable: false,
      // editable: true,
    },
  ];

  // console.log('displayData in displaypage is ',displayData)
  return (
    <>
      {/* <TableContainer component={Paper} className={classes.table}>
          <Table
            // style={{ width: 450 }}
            className={classes.table}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead style={{ backgroundColor: 'red', color: 'white' }}>
              <StyledTableRow key='tableHeaders'>
                <StyledTableCell>Sl. No.</StyledTableCell>
                <StyledTableCell>lead_no</StyledTableCell>
                <StyledTableCell>uniqueLeadNumber</StyledTableCell>
                <StyledTableCell>isRegistered</StyledTableCell>
                <StyledTableCell>floorPlan</StyledTableCell>
                <StyledTableCell>address</StyledTableCell>
                <StyledTableCell>area</StyledTableCell>
                <StyledTableCell>propertyType</StyledTableCell>
                <StyledTableCell>scopeOfWork</StyledTableCell>
                <StyledTableCell>startInteriors</StyledTableCell>
                <StyledTableCell>city</StyledTableCell>
                <StyledTableCell>experienceCenterId</StyledTableCell>
                <StyledTableCell>salesWonExpCtrId</StyledTableCell>
                <StyledTableCell>sourceOfLead</StyledTableCell>
                <StyledTableCell>designUser</StyledTableCell>
                <StyledTableCell>amountPaid</StyledTableCell>
                <StyledTableCell>salesStage</StyledTableCell>
                <StyledTableCell>salesUser</StyledTableCell>
                <StyledTableCell>salesAssistantManager</StyledTableCell>
                <StyledTableCell>salesManager</StyledTableCell>
                <StyledTableCell>salesDGM</StyledTableCell>
                <StyledTableCell>meetingWithCustomer1</StyledTableCell>
                <StyledTableCell>meetingWithCustomer2</StyledTableCell>
                <StyledTableCell>meetingWithCustomer3</StyledTableCell>
                <StyledTableCell>leadWonDate</StyledTableCell>
                <StyledTableCell>staticSalesWonAmount</StyledTableCell>
                <StyledTableCell>staticDesignWonAmount</StyledTableCell>
                
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {renderData?.map((data, i) => {
                return (
                        <StyledTableRow key={i}>
                        <StyledTableCell component="th">{i + 1}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.lead_no ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.uniqueLeadNumber ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.isRegistered ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.floorPlan ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.address ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.area ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.propertyType ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.scopeOfWork ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.startInteriors ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.city?.name ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.experienceCenterId?.name ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.salesWonExpCtrId?.name ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.sourceOfLead?.name ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.designUser?.name ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.amountPaid ?? "N/A"}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.salesStage ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.salesUser ?? "N/A"}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.salesAssistantManager ?? "N/A"}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.salesManager ?? "N/A"}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.salesDGM ?? "N/A"}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.meetingDate ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.meetingStage ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.meetingType ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.leadWonDate ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.staticSalesWonAmount ?? "N/A"}</StyledTableCell>
                        <StyledTableCell component="th" style={{ textAlign: "center" }}>{data?.staticDesignWonAmount ?? "N/A"}</StyledTableCell>
                      )
              })}
            </TableBody>
          </Table>
      </TableContainer> */}

      <div style={{ height: "1500px", width: '100%', marginTop: '50px' }} className='tableContainer'>
        <DataGrid
          rows={displayData}
          // rows={renderData}
          columns={columns}
          pageSize={100}
          rowsPerPageOptions={[100]}
          // checkboxSelection
          disableSelectionOnClick
          // onCellOver
        />
      </div>

    </>

  )
}

export default connect(null, { setLoading, setSnackInfo, setUserDetails })(DisplayPage);